import { FC } from 'react';
import { Button, Icon, useDisclosure } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import useflowsProductBasketStore from '@flows/src/store/zustand/flows-products/flowsProductBasketStore';
import FinishBasketModal from '@flows/src/components/flow-products/quotes/basket/FinishBasketModal';

interface Props {
  sessionId: string;
}

const BasketFinishButton: FC<Props> = ({ sessionId }) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const isBasketValidated = useflowsProductBasketStore(
    (state) => state.isBasketValidated,
  );

  return (
    <>
      <FinishBasketModal
        isOpen={isOpen}
        onClose={onClose}
        sessionId={sessionId}
      />
      <Button
        isDisabled={!isBasketValidated}
        onClick={onOpen}
        rightIcon={<Icon name="GeneralActionsArrowRight" />}
      >
        {t('FINISH')}
      </Button>
    </>
  );
};

export default BasketFinishButton;
